// Import model
import { Customer } from '../models/Customer';

// Import base class serializer
import { EntityOwnedModelSerializer } from './EntityOwnedModelSerializer';

// Import dependency types (models and enums used in properties)
import { SfCustomer } from '../models/SfCustomer';

// Import dependency serializers (for complex types)
import { SfCustomerSerializer } from './SfCustomerSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for Customer - handles JSON serialization and deserialization with type validation
 */
export class CustomerSerializer {
  /**
   * Deserializes a JSON string into a Customer instance
   */
  static deserialize(json: string): Customer {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a Customer instance
   */
  static fromObject(obj: any): Customer {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to Customer');
    }


    const instance: Customer = {
      name: obj['name'] as string | undefined,
      description: obj['description'] as string | undefined,
      entityId: obj['entityId'] as string | undefined,
      entityIdName: obj['entityId|Name'] as string | undefined,
      id: obj['_id'] as string | undefined,
      createdDate: obj['createdDate'] as string | undefined,
      externalId: obj['externalId'] as string | undefined,
      isActive: obj['isActive'] as boolean | undefined,
      properties: obj['properties'] ? SfCustomerSerializer.fromObject(obj['properties']) : undefined as any,
      flowId: obj['flowId'] as string | undefined,
      flowIdName: obj['flowId|Name'] as string | undefined,
      objectStatusId: obj['objectStatusId'] as string | undefined,
      objectStatusIdName: obj['objectStatusId|Name'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of Customer instances
   */
  static deserializeArray(json: string): Customer[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a Customer instance to a JSON string
   */
  static serialize(instance: Customer): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a Customer instance to a plain object
   */
  static toObject(instance: Customer): any {
    return {
      'name': instance.name,
      'description': instance.description,
      'entityId': instance.entityId,
      'entityId|Name': instance.entityIdName,
      '_id': instance.id,
      'createdDate': instance.createdDate,
      'externalId': instance.externalId,
      'isActive': instance.isActive,
      'properties': instance.properties ? SfCustomerSerializer.toObject(instance.properties) : undefined,
      'flowId': instance.flowId,
      'flowId|Name': instance.flowIdName,
      'objectStatusId': instance.objectStatusId,
      'objectStatusId|Name': instance.objectStatusIdName,
    };
  }

  /**
   * Serializes an array of Customer instances to a JSON string
   */
  static serializeArray(instances: Customer[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
